import { colors } from "@src/style/variables"

export function nodePaint({ id, x, y, value, random }, color, ctx, selected) {
  var w = 100 + Math.max(0, (value.length - 5) * 10)
  var h = 50 + random * 20
  var radius = 8
  var fontHeight = 20
  var direction = Math.floor(random * 100) % 2
  var shape = true

  var r = x + w
  var b = y + h

  var otherColor =
    color === colors.white || color === colors.offWhite
      ? colors.black
      : colors.white

  ctx.beginPath()
  ctx.fillStyle = color
  ctx.strokeStyle = otherColor

  ctx.lineWidth = "2"

  if (shape) {
    ctx.moveTo(r - radius, y)
    ctx.quadraticCurveTo(r, y, r, y + radius)
    ctx.lineTo(r, y + h - radius)
    ctx.quadraticCurveTo(r, b, r - radius, b)
    ctx.lineTo(x + radius, b)
    ctx.quadraticCurveTo(x, b, x, b - radius)
    ctx.lineTo(x, y + radius)
    ctx.quadraticCurveTo(x, y, x + radius, y)
    ctx.lineTo(r - radius, y)
  } else {
    drawEllipse(ctx, x, y, w, h, r - radius, y + h)
  }
  // ctx.stroke()
  ctx.fill()

  if (direction) {
    ctx.moveTo(r, y + h / 2)
    ctx.lineTo(x + radius / 2, y + h + 10)
    ctx.lineTo(x + w * 0.25, y + h / 2)
    // ctx.lineTo(r - radius, y + h)
  } else {
    ctx.moveTo(r - w * 0.25, y + h / 2)
    ctx.lineTo(r, y + h + 10)
    ctx.lineTo(x, y + h / 2)
    // ctx.lineTo(x + radius, y + h)
  }
  if (selected) {
    ctx.stroke()
  }
  ctx.fill()

  ctx.fillStyle = otherColor
  ctx.font = `${fontHeight}px GT Flexa Trial`
  ctx.fillText(value.toUpperCase(), x + 20, y + h / 2 + fontHeight / 3)
}

export function drawEllipse(ctx, x, y, w, h, toX, toY) {
  var kappa = 0.5522848,
    ox = (w / 2) * kappa, // control point offset horizontal
    oy = (h / 2) * kappa, // control point offset vertical
    xe = x + w, // x-end
    ye = y + h, // y-end
    xm = x + w / 2, // x-middle
    ym = y + h / 2 // y-middle

  ctx.beginPath()
  ctx.moveTo(x, ym)
  ctx.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y)
  ctx.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym)
  ctx.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye)
  ctx.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym)
}
